module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Maggie Barbieri\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Maggie Barbieri, author of "), _c('I', [_vm._v("Quick Study")]), _vm._v(", is a freelance editor as well as a mystery novelist. Her father was a member of the NYPD, and his stories about being a motorcycle and a beat cop provide much of the background for her mysteries. This is her fourth Murder 101 mystery; Kristin Davis of Sex and the City has optioned the series for television. Maggie lives in Westchester County, New York.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Xu0pHZ/tc-custom/9781429983044.jpg?1742449793345",
      "alt": "This image is the cover for the book Final Exam, The Murder 101 Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Final Exam, The Murder 101 Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("St. Thomas, the small college north of New York City where Professor Alison Bergeron teaches, has had its share of scandals involving both its students and its staff, not to mention Alison herself, so when a resident director goes missing the administration wants to keep a lid on it. With only five weeks left in the semester and no time to interview replacements, Alison is tapped for the job. An alumna of the college, Alison knows all about living in the dorms. Even a short stay is like doing hard time, and she will do anything to avoid reliving her college days any more than she has to."), _c('br'), _c('br'), _vm._v("Her only way out: Track down the reluctant RD and drag him back kicking and screaming if need be. Luckily, she doesn't have to look further than the drugs he had hidden in his bathroom to get her boyfriend, Detective Bobby Crawford, on the case.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Minotaur Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0